import React from "react";
import { activateDialog } from "./dialogFocus";
/**
 * The volunteer dialog: the volunteer's photo (or their initials when there is none), the name and
 * the phone number as a button that opens the phone app. Escape, the cross, "Luk" and a tap on the
 * backdrop all close it. Plain React like ConfirmDialog, on the same backdrop.
 */
export default class MemberDialog extends React.Component {
    constructor() {
        super(...arguments);
        this.dialogRef = React.createRef();
    }
    componentDidMount() {
        var _a;
        // Taken before the dialog takes the focus, so it is the opener that gets it back.
        this.deactivate = activateDialog(() => this.dialogRef.current, () => this.props.onClose());
        // The dialog itself takes the focus, so no button looks pressed before it is used.
        (_a = this.dialogRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    componentWillUnmount() {
        var _a;
        (_a = this.deactivate) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /** The member's own photo, or undefined for the generic avatar the server serves when there is none. */
    static photo(url) {
        return url && !url.includes("generic-avatar") ? url : undefined;
    }
    static initials(name) {
        const parts = (name !== null && name !== void 0 ? name : "").split(" ").filter((p) => p.length > 0);
        if (parts.length === 0)
            return "";
        return (parts.length === 1 ? parts[0][0] : parts[0][0] + parts[parts.length - 1][0]).toLocaleUpperCase("da");
    }
    // A Danish eight-digit number is read in pairs: 42 11 96 38.
    static formatPhone(phoneNo) {
        const digits = (phoneNo !== null && phoneNo !== void 0 ? phoneNo : "").replace(/[^\d+]/g, "");
        return /^\d{8}$/.test(digits) ? digits.replace(/(\d\d)(?=\d)/g, "$1 ") : phoneNo;
    }
    render() {
        const { name, phoneNo, pictureUrl, onClose } = this.props;
        const digits = (phoneNo !== null && phoneNo !== void 0 ? phoneNo : "").replace(/[^\d+]/g, "");
        const shown = MemberDialog.formatPhone(phoneNo);
        return (React.createElement("div", { className: "bp-dialog-backdrop", onClick: onClose },
            React.createElement("div", { className: "bp-dialog bi-member-dialog", ref: this.dialogRef, tabIndex: -1, role: "dialog", "aria-modal": "true", "aria-label": name, onClick: (e) => e.stopPropagation() },
                React.createElement("button", { type: "button", className: "bi-icon-btn bi-member-dialog-close", "aria-label": "Luk", onClick: onClose },
                    React.createElement("i", { className: "fa-solid fa-xmark", "aria-hidden": "true" })),
                pictureUrl
                    ? React.createElement("img", { className: "bi-member-photo", src: pictureUrl, alt: `Profilbillede af ${name}` })
                    : React.createElement("span", { className: "bi-member-photo bi-member-initials", "aria-hidden": "true" }, MemberDialog.initials(name)),
                React.createElement("h2", null, name),
                digits
                    ? React.createElement("a", { className: "bi-call-large", href: `tel:${digits}`, "aria-label": `Ring til ${name} på ${shown}` },
                        React.createElement("i", { className: "fa-solid fa-phone", "aria-hidden": "true" }),
                        shown)
                    : React.createElement("p", { className: "bi-empty" }, "Telefonnummer er ikke angivet"),
                React.createElement("button", { type: "button", className: "btn btn-outline-secondary bi-member-dialog-done", onClick: onClose }, "Luk"))));
    }
}
